<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.useWheelchair' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__radio" role="radiogroup" aria-invalid="false">
          <legend class="p-support-info__radio-legend" [innerHTML]="'label.useWheelchair' | staticMsg"></legend>
          <div class="p-support-info__radio-list">
            <!-- [14.11] 車いす持ち込み有無 -->
            <div class="p-support-info__radio-item" *ngFor="let item of wheelchairsSelectList; index as idx">
              <input
                type="radio"
                name="radio1"
                id="radio1_{{ idx + 1 }}"
                class="p-support-info__radio-item-input"
                (change)="onChangeWillBeCheckedIn(item.value)"
                [checked]="willBeCheckedIn === item.value"
              />
              <label for="radio1_{{ idx + 1 }}" class="p-support-info__radio-item-label">
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text" [innerHTML]="item.label | staticMsg"></span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      <asw-validation-error
        *ngIf="selectError"
        id="{{ id }}_check-in-wheelchair-error"
        [errorMessage]="selectError"
      ></asw-validation-error>
    </div>
  </div>
</div>
